import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { EdeliveryLabels } from '../../i18n/edelivery-labels';
import { PershingTranslationService } from '@pershing/pershing-core';
import { EDeliveryService } from '../../services/edelivery.service';
// import { Context } from '../../models/context.model';


@Component({
  selector: 'e-delivery-ems',
  templateUrl: './e-delivery-ems.component.html',
  // styleUrls: ['@import https://www.pllcfiles.com/nxc.nxi-branding/21.408.1/assets/css/build/global.css']
  styleUrls: ['./e-delivery-ems.component.css']
  // styleUrls: ['@import url(https://www.pllcfiles.com/nxc.nxi-branding/21.408.1/assets/css/build/global.css);@import url(https://www.pllcfiles.com/nxc.nxi-branding/21.408.1/assets/css/build/portal/conservative/portal.css);@import url(https://www.pllcfiles.com/nxc.nxi-branding/21.408.1/assets/css/build/components/retail/components.css);@import url(https://www.pllcfiles.com/nxc.nxi-branding/21.408.1/assets/css/build/theme/conservative/theme.css)']
})
export class EdeliveryEmsComponent implements OnInit {

  @Input() ibd: string;
  @Input() subscriberId: string;
  @Input() loginId: string;
  @Input() businessPartyRole: string;
  @Input() businessPartyValue: string;
  @Input() clientId: string;
  @Output() closeEdelivery = new EventEmitter<boolean>();

  edeliveryPreferencesTitle: any = EdeliveryLabels.EDELIVERY_PREFERENCES_TITLE;
  returnToEmsLabel: any = EdeliveryLabels.RETURN_TO_EMS;

  constructor(private eDeliveryService: EDeliveryService, private translate: PershingTranslationService) {
    if (this.translate) {
      this.translate.addTranslationFolder('@pershing/edc-newedelivery', 'node_modules/@pershing/edc-newedelivery/lib');
    }
    // eDeliveryService.contextData = new Context();
    // eDeliveryService.contextData.subscriberId = 'JAYANTQA';
    // eDeliveryService.contextData.ibdId = '3CR';
    // eDeliveryService.contextData.advisorId = 'TSOJGUP';
    // eDeliveryService.setContextData('RDA', '360284426734298', 'BASKARTEST123', '01A', 'RDAIF0000', 'EMS');
    // if (this.subscriberId !== undefined && this.subscriberId !== '') {
    //   eDeliveryService.contextData = new Context();
    //   eDeliveryService.contextData.subscriberId = this.subscriberId;
    //   eDeliveryService.contextData.ibdId = this.ibdId;
    //   eDeliveryService.contextData.advisorId = this.advisorId;
    // }
  }

  ngOnInit(): void {
    this.eDeliveryService.setContextData(this.ibd.toUpperCase(), this.subscriberId.toUpperCase(), this.loginId, this.businessPartyRole, this.businessPartyValue, this.clientId);
  }

  ngOnDestroy(): void {
  }

  returnToEms(): void {
    // document.dispatchEvent(new CustomEvent('portal.emsReturnToEmsEvent'));
    this.closeEdelivery.emit(true);
  }
}
